import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";

import { ProductTileImageProps } from "../../../ComposableProductTile/__internal__/__internal__/components/ProductImage/ProductTileImageProps";
import { getImage } from "../../../ProductDetailsTile/getImage";
import { IProductTileImageConfigProps } from "../../types";

export const productTileImageAdapter = (
  productTile: ILeanProductTile,
  productTileImageConfigProps?: IProductTileImageConfigProps
): ProductTileImageProps => {
  return {
    image: getImage(productTile),
    imageAltText:
      productTileImageConfigProps?.altTag ??
      productTile.best_image?.alt_text ??
      "",
    shouldUseLazyImageLoading: false,
    showVerticalImagery:
      productTileImageConfigProps?.showVerticalImagery ?? false,
    onLoad: undefined,
    optionDetails: productTile.options_details,
  };
};
